export default "__VITE_ASSET__XP$z2H5f__"